<template>
  <div class="ad-task-page">
    <layout>
      <template v-slot:search>
        <div class="search-wrapper">
          <div v-if="media === 'juliang'" style="margin-bottom: 16px;">
            <a-radio-group v-model="deliveryType" @change="onDeliveryTypeChange">
              <a-radio-button value="bid">竞价投放</a-radio-button>
              <a-radio-button value="uni">全域投放</a-radio-button>
            </a-radio-group>
          </div>
          <div class="title"><a-icon type="search" /> 数据筛选 </div>
          <a-divider></a-divider>
          <a-space>
            <a-select show-search allow-clear placeholder="所属主体" v-model="queryParam.corporation_id"  option-filter-prop="children">
              <a-select-option :value="corporation.id" v-for="corporation in corporations" :key="corporation.id" >
                {{ corporation.name }}
              </a-select-option>
            </a-select>
            <a-input allow-clear placeholder="任务ID" v-model="queryParam.task_id" />
            <a-input allow-clear placeholder="名称" v-model="queryParam.name" />
            <a-select show-search allow-clear placeholder="来源" v-model="queryParam.source_type"  option-filter-prop="children">
              <a-select-option :value="item.id" v-for="item in sourceTypes" :key="item.id" >
                {{ item.name }}
              </a-select-option>
            </a-select>
            <a-button type="primary" @click="search" title="点击回车直接查询" style="border:1px solid gold">查询 <span style="color:gold;font-size:10px"> (支持回车) </span></a-button>
            <a-button @click="resetSearch">重置</a-button>
          </a-space>
        </div>
      </template>

      <template v-slot:content>
        <vxe-grid
          class="table-scrollbar"
          v-bind="tableGrid"
          @page-change="handlePageChange"
          @sort-change="handleSortChange"
          @checkbox-change="handleRowChange"
          @checkbox-all="handleRowChange"
        >
          <template #result="{ row }">
            <div class="result" @click="showResult(row)">
              <span>{{ row.success.length }}</span>/<template v-if="deliveryType === 'uni' && media === 'juliang'">{{ (row.params && row.params.aweme_id ? row.params.aweme_id.length : 0) }}</template><template v-else>{{ row.advertiser_ids.length }}</template>
            </div>
          </template>
          <template #toolbar_buttons>
            <a-space class="table-operator">
              <template v-if="deliveryType === 'bid'">
                <a-button type="primary" icon="plus" @click="create" v-if="accessTo('store')">新建任务</a-button>
                <a-button type="primary" icon="plus" @click="createV1" v-if="accessTo('store') && media === 'juliang'">新建任务(端)</a-button>
                <a-button type="primary" icon="plus" @click="createUg" v-if="accessTo('store') && media === 'juliang'">新建任务(UG)</a-button>
                <a-button type="primary" icon="plus" @click="createNew" v-if="accessTo('store') && media === 'kuaishou'">新建任务(新)</a-button>
              </template>
              <template v-if="deliveryType === 'uni' && media === 'juliang'">
                <a-button type="primary" icon="plus" @click="createUni" v-if="accessTo('store')">新建任务(全域)</a-button>
              </template>
              <a-button icon="cloud-upload" @click="upload($event, 'create')" v-if="accessTo('store') && media === 'kuaishou'">视频直传快手账户</a-button>

              <a-dropdown :disabled="selectedRowKeys.length === 0" v-if="accessTo('destroy')">
                <a-menu slot="overlay">
                  <a-menu-item key="1" @click="destroy()"><a-icon type="delete" />删除</a-menu-item>
                  <a-menu-item key="2" @click="shared()" v-if="accessTo('shared') && !(deliveryType === 'uni' && media === 'juliang')"><a-icon type="plus" />共享</a-menu-item>
                </a-menu>
                <a-button> 批量操作 <a-icon type="down" /></a-button>
              </a-dropdown>

            

            </a-space>
          </template>
          <template #status="{ row }">
            <a-tag :color="row.status|statusColor">{{ $helper.getItemName(status, row.status) }}</a-tag>
          </template>
          <template #action="{ row }">
            <div class="actions">
              <template v-if="accessTo([
                'update',
                'destroy'
              ])">
                <!-- 全域投放：仅保留一个复制，与新增页面一致 -->
                <template v-if="deliveryType === 'uni' && media === 'juliang'">
                  <a href="javascript:;" @click="createUni(row)" v-if="accessTo('update')">复制</a>
                  <a-divider type="vertical" />
                  <!-- 复制该任务下的全部广告主ID（多个换行分隔，便于直接粘贴到巨量平台） -->
                  <a href="javascript:;" @click="copyAdvertiserIds(row)">复制广告主ID</a>
                  <a-divider type="vertical" />
                  <a-popconfirm title="确认要删除吗?" @confirm="destroy(row)" v-if="accessTo('destroy')">
                    <a href="javascript:;">删除</a>
                  </a-popconfirm>
                </template>
                <!-- 竞价投放：保留原有操作 -->
                <template v-else>
                  <a href="javascript:;" @click="createV1(row)" v-if="accessTo('update') && media === 'juliang'">复制(端)</a>
                  <a-divider type="vertical" />
                  <a href="javascript:;" @click="createUg(row)" v-if="accessTo('update') && media === 'juliang'">复制(UG)</a>
                  <a-divider type="vertical" />
                  <a href="javascript:;" @click="create(row)" v-if="accessTo('update')">复制</a>
                  <a-divider type="vertical" />
                  <a href="javascript:;" @click="createNew(row)" v-if="accessTo('update') && media === 'kuaishou'">复制(新)</a>
                  <a-divider type="vertical" />
                  <a href="javascript:;" @click="shared(row)" v-if="accessTo('shared')">共享</a>
                  <a-divider type="vertical" />
                  <a-popconfirm title="确认要删除吗?" @confirm="destroy(row)" v-if="accessTo('destroy')">
                    <a href="javascript:;">删除</a>
                  </a-popconfirm>
                </template>
              </template>
              <template v-else>-</template>
            </div>
          </template>
        </vxe-grid>
      </template>
    </layout>

    <a-modal
      title="执行结果"
      centered
      :width="640"
      :mask-closable="false"
      :visible="result.success.length + result.errors.length > 0"
      :footer="null"
      @cancel="close"
    >
      <div class="result-box">
        <div v-for="(item, index) in result.success" :key="'s' + index">{{ item }}</div>
        <div class="text-red" v-for="(item, index) in result.errors" :key="'e' + index"><br>{{ item }}</div>
      </div>
    </a-modal>

    <juliang-form
      v-if="showForm && media === 'juliang'"
      :showCreateForm.sync="showForm"
      :params="model"
      :media="media"
      @success="refresh"
    />

    <juliang-v1-form
      v-if="showV1Form && media === 'juliang'"
      :showCreateForm.sync="showV1Form"
      :params="model"
      :media="media"
      @success="refresh"
    />

    <juliang-ug-form
      v-if="showUgForm && media === 'juliang'"
      :showCreateForm.sync="showUgForm"
      :params="model"
      :media="media"
      @success="refresh"
    />

    <kuaishou-form
      v-if="showForm && media === 'kuaishou'"
      :showCreateForm.sync="showForm"
      :params="model"
      :media="media"
      @success="refresh"
    />

    <kuaishou-new-form
      v-if="showNewForm && media === 'kuaishou'"
      :showCreateForm.sync="showNewForm"
      :params="model"
      :media="media"
      @success="refresh"
    />

    <baidu-form
      v-if="showForm && media === 'baidu'"
      :showCreateForm.sync="showForm"
      :params="model"
      :media="media"
      @success="refresh"
    />

    <upload
      v-if="showUpload && media === 'kuaishou'"
      :showUpload.sync="showUpload"
      :model="model"
      :media="media"
      @success="refresh"
    />

    <juliang-uni-form
      v-if="showUniForm && media === 'juliang'"
      :showCreateForm.sync="showUniForm"
      :params="model"
      :media="media"
      @success="refresh"
    />

    <shared-form
        v-if="showSharedForm"
        :showSharedForm.sync="showSharedForm"
        :model="model"
        @success="refresh"
      />

  </div>
</template>

<style lang="less" scoped>
@import 'AdTask';
</style>

<script>
import AdTask from './AdTask'
export default AdTask
</script>
